import React, { useState, useContext } from 'react';
import styled from '@emotion/styled';
import agriplan from 'assets/user-access/agriplan.svg';
import comhub from 'assets/user-access/comhub.svg';
import fsm from 'assets/user-access/fsm.svg';
import { useNavigate } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";

const CarouselContainer = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;

const Card = styled.div`
  background-color: ${(props) => (props.active ? '#f4f5f9' : '#d9d9d9')}; // Gray background for inactive cards
  display: flex;
  border: 1px solid #ccc;
  width: 300px;
  height: 400px;
  border-radius: 10px;
  padding: 20px;
  margin: 10px;
  flex: 0 0 30%; /* Each card takes up 30% of the container */
  transition: background-color 0.3s;
  box-sizing: border-box; /* Ensures padding and border are included in the width */
  opacity: ${(props) => (props.active ? 1 : 0.6)}; // Lower opacity for inactive cards
  pointer-events: ${(props) => (props.active ? 'auto' : 'none')}; // Disable pointer events for inactive cards
  
  &:hover {
    color: white; // Change text color on hover
     background-color: #0A3575; // Gray background for inactive cards
    img {
      filter: brightness(0) invert(1); // Change image color to white
    }
  }
`;

const Button = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: #fff; /* Change background for visibility */
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
  font-size: 24px;
  color: #000;
  z-index: 1;

  &:hover {
    background-color: #0A3575; /* Change background on hover */
    color: white; /* Change text color on hover */
  }

  &:nth-of-type(1) {
    left: -50px; /* Position left button 50px from the left */
  }

  &:nth-of-type(2) {
    right: -50px; /* Position right button 50px from the right */
  }
`;

const Carousel = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState(0); // Start from the first card
  const navigate = useNavigate();
  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);

  const next = () => {
    if (currentIndex < items.length - 3) { // Adjust condition for 3 visible cards
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleCardClick = (item) => {
    if (item.title === 'Agri360 ESG Portal') {
      navigate("/dashboard");
    } else {
      setSeverity("error");
      setMessage("Operation not allowed!");
      setOpenAlert(true);
    }
  }

  return (
    <div style={{ position: 'relative', width: '100%', maxWidth: '800px', margin: 'auto', color: "#0A3575" }}>
      <CarouselContainer>
        <Button onClick={prev}>&lt;</Button>
        {items.slice(currentIndex, currentIndex + 3).map((item, index) => (
          <Card key={index} active={index === 1} onClick={() => handleCardClick(item)} style={{ display: "flex", flexDirection: "column", justifyContent: "center", textAlign: "center", alignItems: "center",cursor:"pointer" }}>
            <img src={item.content} alt={item.title} style={{ width: '100%', height: '100px', transition: 'filter 0.3s' }} />
            <div className='cardHeading1'>{item.title}</div>
            <div className='cardHeading2'>{item.mvp}</div>
          </Card>
        ))}
        <Button onClick={next}>&gt;</Button>
      </CarouselContainer>
    </div>
  );
};

const App = () => {
  const items = [
    { title: 'Agri Planning', content: agriplan, mvp: 'MVP01' },
    { title: 'Agri360 ESG Portal', content: fsm, mvp: 'MVP02' },
    { title: 'Commercial Hub', content: comhub, mvp: 'MVP03' },
    { title: 'Card 4', content: agriplan, mvp: 'MVP04' },
    { title: 'Card 5', content: fsm, mvp: 'MVP05' },
  ];

  return (
    <div style={{ padding: '20px' }}>
      <Carousel items={items} />
    </div>
  );
};

export default App;
